{
  "personal-data-form": {
    "text": {
      "birthday": "Birthday",
      "name": "Name",
      "surname": "Surname"
    }
  }
}
